<!-- Sidebar shell now lives in the Workspace parent route (workspace.html); app-root
     only renders the top-level outlet (login, print, redirect, and the workspace). -->
<router-outlet></router-outlet>
<app-version-popup></app-version-popup>
<!-- Only once the login has completed: UID is already set while the clinic picker (and, for
     Artisan support, the user picker) is still open, and the widget must not appear there. -->
<app-support-widget
  *ngIf="loginS.UID && loginS.loginComplete && loginS.supportCenterEnabled"
></app-support-widget>
<app-announcement-host></app-announcement-host>
